import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const isSettingsActive = (settings) =>
  settings?.isActive !== undefined
    ? settings.isActive
    : (settings?.is_active === 1 || settings?.is_active === true);

const GAME_DEFS = [
  {
    key: 'blackjack',
    to: '/games/blackjack',
    name: 'Blackjack',
    emoji: '🃏',
    defaultLogo: '/images/originals/blackjack.png',
    description: "Klasik blackjack oyunu. 21'e en yakın olan kazanır!",
    accent: 'from-amber-500/20 to-gold/10'
  },
  {
    key: 'mines',
    to: '/games/mines',
    name: 'Mines',
    emoji: '💣',
    defaultLogo: '/images/originals/mines.png',
    description: 'Mayınlardan kaçının, güvenli kareleri açtıkça çarpanınız yükselsin.',
    accent: 'from-emerald-500/20 to-teal-700/10'
  },
  {
    key: 'limbo',
    to: '/games/limbo',
    name: 'Limbo',
    emoji: '🚀',
    defaultLogo: '/images/originals/limbo.png',
    description: 'Hedef çarpanınızı seçin, şansınızı deneyin — çarpan 1.000.000×\'e kadar çıkabilir!',
    accent: 'from-sky-500/20 to-indigo-700/10'
  }
];

const GamesPage = () => {
  const [settingsByGame, setSettingsByGame] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAll = async () => {
      const entries = await Promise.all(
        GAME_DEFS.map(async (g) => {
          try {
            const res = await axios.get(`/api/games/settings/${g.key}`);
            return [g.key, res.data];
          } catch (error) {
            return [g.key, null];
          }
        })
      );
      setSettingsByGame(Object.fromEntries(entries));
      setLoading(false);
    };
    fetchAll();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-gold"></div>
      </div>
    );
  }

  const activeGames = GAME_DEFS.filter((g) => isSettingsActive(settingsByGame[g.key]));

  return (
    <div className="w-full px-4 py-12">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-5xl font-bold text-center text-gold mb-4 drop-shadow-[0_0_20px_rgba(212,175,55,0.8)]">
          Saguex Originals
        </h1>
        <p className="text-xl text-center text-white/80 mb-12">
          Sagu Coin'lerinizle eğlenceli oyunlar oynayın!
        </p>

        {activeGames.length === 0 ? (
          <p className="text-xl text-center text-white/80">Şu anda aktif oyun bulunmamaktadır.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {activeGames.map((game) => {
              const settings = settingsByGame[game.key] || {};
              const logoUrl = settings.logoUrl || settings.logo_url || game.defaultLogo;
              return (
                <Link
                  key={game.key}
                  to={game.to}
                  className="group relative overflow-hidden rounded-2xl border-2 border-gold/30 hover:border-gold transition-all duration-300 hover:shadow-[0_0_35px_rgba(212,175,55,0.45)] transform hover:-translate-y-2 bg-gradient-card"
                >
                  <div className="relative aspect-[3/4] w-full overflow-hidden">
                    {logoUrl ? (
                      <img
                        src={logoUrl}
                        alt={game.name}
                        className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling?.classList.remove('hidden');
                        }}
                      />
                    ) : null}
                    <div className={`${logoUrl ? 'hidden' : ''} absolute inset-0 flex items-center justify-center bg-gradient-to-br ${game.accent}`}>
                      <span className="text-7xl">{game.emoji}</span>
                    </div>
                    <div className="pointer-events-none absolute inset-x-0 bottom-0 h-2/5 bg-gradient-to-t from-black/85 via-black/40 to-transparent" />
                    <div className="absolute inset-x-0 bottom-0 p-5 text-center">
                      <div className="inline-block bg-gold/90 group-hover:bg-gold px-6 py-2.5 rounded-lg transition-colors">
                        <span className="text-navy-900 font-bold">Oyna</span>
                      </div>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default GamesPage;
